export const SITE_ENGINEER_DETAILS = "SITE_ENGINEER_DETAILS";
